import { Map as NSMap } from './map';

import { NSMapInterface } from './map_interface.js';

import { NSServerCalls } from './utils/servercalls';

import { Overlays as NSMapLayersManager } from './overlays.js'

import { URN } from './utils/urn';

import { NSObjDetailsGeo } from './obj_details_geo';


export let NSStreetView = {}

/**
 * @returns promise
 */
NSStreetView.init = function()
{
    let o_promise_result = new Promise((resolve, reject) => 
        {
        
            NSStreetViewPrivate.init( resolve );
        }
    );


    this.f_is_enabled =                 function () { return NSStreetViewPrivate.f_is_enabled.apply( NSStreetViewPrivate, arguments ); };
    this.f_process_map_click =          function () { return NSStreetViewPrivate.f_process_map_click.apply( NSStreetViewPrivate, arguments ); };
    this.f_get_geoserver_layer_name =   function () { return NSStreetViewPrivate.f_get_geoserver_layer_name.apply( NSStreetViewPrivate, arguments ); };
    this.f_enable =                     function () { return NSStreetViewPrivate.f_enable.apply( NSStreetViewPrivate, arguments ); };
    this.f_disable =                    function () { return NSStreetViewPrivate.f_disable.apply( NSStreetViewPrivate, arguments ); };


    window.NSStreetView_ = NSStreetView;
    window.NSStreetViewPrivate_ = NSStreetViewPrivate;

    
    return o_promise_result;
    
}


let NSStreetViewPrivate = 
{
    private_objs:
    {
        b_is_enabled: false,
        // const s_urn_separator = '__SEP__';
        o_sv_node: {
            id: 10000000,
            type: 'wmts',
            urn: 'urn__SEP__table__SEP__landbase__SEP__vistas_rua'
            //geo_server_layer_name: 'vistas_rua'
        },
        geo_server_layer_name: 'vistas_rua',
        feature: null, // selected streetview point

        o_highlight: {}, // NSObjDetailsGeo.objs.GeoHighlight()

    },

    init: function(f_cb_in)
    {

        this.private_objs.o_highlight = new NSObjDetailsGeo.objs.GeoHighlight();
        
    },

     f_is_enabled: function()
     {
         return this.private_objs.b_is_enabled;
     },

     f_get_geoserver_layer_name: function()
     {
         return this.private_objs.geo_server_layer_name;
     },
     f_enable: function()
     {
        this.private_objs.b_is_enabled = true;
         NSMapLayersManager.f_add_layer(this.private_objs.o_sv_node);
     },
     f_disable: function()
     {
        this.private_objs.b_is_enabled = false;
		NSMapLayersManager.f_remove_layer(this.private_objs.o_sv_node);
        this.f_clear_highlight();
     },

    f_process_map_click(pixel)
    {

        let a_bounding_box = this.f_get_extent_from_pixel(pixel, 5);

        this.f_clear_highlight();

        const f_callback = (res) => {
            this.f_handle_response(res.features);
        };

        const a_layers = [this.private_objs.geo_server_layer_name];

        const s_cql_filter = this.f_generate_request_filter(a_layers, a_bounding_box);

        NSServerCalls.geoserver.wfs.get_feature(a_layers.join(), 1000, null, null, null, f_callback, null, null, s_cql_filter);

    },
    // similar to a method with the same name in NSFeaturesSelect
    f_get_extent_from_pixel: function (pixel, offset) {
        const a_sw = NSMap.map.getCoordinateFromPixel([pixel[0] - offset, pixel[1] + offset]);
        const a_ne = NSMap.map.getCoordinateFromPixel([pixel[0] + offset, pixel[1] - offset]);
        return [...a_sw, ...a_ne];
    },
    // similar to a method with the same name in NSFeaturesSelect
    f_generate_polygon_coordinates: function (a_bounding_box) {
        return [
            [a_bounding_box[0], a_bounding_box[1]],
            [a_bounding_box[0], a_bounding_box[3]],
            [a_bounding_box[2], a_bounding_box[3]],
            [a_bounding_box[2], a_bounding_box[1]],
            [a_bounding_box[0], a_bounding_box[1]],
        ];
    },
    // similar to a method with the same name in NSFeaturesSelect
    f_generate_request_filter: function (a_unique_active_layers, a_bounding_box) {
        const s_polygon_coordinates_filter = this.f_generate_polygon_coordinates(a_bounding_box).map((el) => el.join(' '));
        const s_filter_template = `INTERSECTS(__GEOM__,POLYGON((${s_polygon_coordinates_filter})))`;
        const a_filters = [];

        const geometry_urn = "geom";
        a_filters.push(s_filter_template.replace('__GEOM__', geometry_urn));

        return a_filters.join(';');
    },

    f_handle_response: function (res) {
        try {

            let layer_name = this.private_objs.geo_server_layer_name;
            let urn = this.private_objs.o_sv_node.urn;

            if( res != null && res.length > 0)
            {
                let o_feature = res[0];
                
                const [s_layer_name, s_record_id] = o_feature.id.split('.');
                const feature_urn = URN.f_create_record_urn_from_table_urn(urn, s_record_id);

                o_feature.urn = feature_urn;

                this.private_objs.feature = o_feature;

                
                // add new highlight
                const o_geo_in = new NSObjDetailsGeo.objs.AddFromGeojsonGeometryIn({
                    s_guid: feature_urn,
                    urn: feature_urn,
                    o_geojson_feature_geometry: o_feature.geometry,
                    style_simple: new NSObjDetailsGeo.objs.GeoHighlightStyleSimpleIn({
                        b_add_displacement_to_highlight_an_icon: false,
                        a_icon_size_xy: null,
                        color: 'rgba(255, 0, 0, 0.4)'
                    }),
                });

                this.f_add_highlight(o_geo_in);

                /*
                alert("go vistas!");
                console.log("streetview returned feature:");
                console.log(o_feature);
                */

                let b_open_vistas_rua_mode=true;
                /*
                let x = o_feature.properties.long_etrs8;
                let y = o_feature.properties.lat_etrs89;
                */
                let x = o_feature.geometry.coordinates[0]; // CRS 3857
                let y = o_feature.geometry.coordinates[1]; // CRS 3857
               
                NSMapInterface.f_open_vistas_sv_mode(b_open_vistas_rua_mode ,x, y)
                
            }

        } catch (err) {
            console.log('Failed to read response');
        }
    },
    f_add_highlight: function (o_geo_in) {
        this.private_objs.o_highlight.f_add_from_geojson_geometry(o_geo_in);
    },
    f_remove_highlight: function (s_guid) {
        this.private_objs.o_highlight.f_remove(s_guid);
    },
    f_clear_highlight: function () {
        this.private_objs.o_highlight.f_remove_all();
    }



}